import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { clippingParents } from '@popperjs/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  // NOTA: PASSKEY se mantiene temporalmente hasta que el backend implemente la gestión de claves
  private secretKey = environment.PASSKEY; // 🔑 Clave de 16 caracteres

  private iv = CryptoJS.enc.Utf8.parse('vector-de-16byt'); // IV de 16 by

  
  decryptData(encryptedData: string, secretKey: string = this.secretKey): string {
    // Log seguro: solo registro operación sin exponer datos sensibles
    console.log('Iniciando proceso de desencriptación - ID:', Date.now());
  
    // Decodificar Base64 manualmente usando atob()
    const decodedBase64 = atob(decodeURIComponent(encryptedData));
    console.log('Base64 decodificado exitosamente');
  
    // Convertir Base64 a un WordArray binario
    const decodedData = CryptoJS.enc.Latin1.parse(decodedBase64);
    console.log('Datos convertidos a WordArray');
  
    // Extraer IV (primeros 16 bytes)
    const iv = CryptoJS.lib.WordArray.create(decodedData.words.slice(0, 4), 16);
    console.log('IV extraído correctamente');
  
    // Extraer datos cifrados (resto de la cadena después del IV)
    const encryptedBytes = CryptoJS.lib.WordArray.create(decodedData.words.slice(4));
    console.log('Datos cifrados procesados');
  
    // Convertir secretKey a formato adecuado
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    console.log('Clave secreta inicializada');
  
    // Desencriptar usando AES-128 con IV gestionado
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedBytes } as CryptoJS.lib.CipherParams, 
      key, 
      { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
  
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    console.log('Desencriptación completada:', decryptedText ? 'ÉXITO' : 'ERROR');
  
    return decryptedText;
  }
}